import { createClient } from "@workspace/auth/client";

export const authClient = createClient({
  fetchOptions: {
    headers: {
      "x-client-platform": "web-client",
    },
    throw: true,
  },
});
